import { patternListChoices, ucfirst } from "../../../helper/tools";

export default function FirstnameForm({ onChange, value, required }) {
    const handleChange = (e) => {
        e.target.value = ucfirst(e.target.value.trim());
        onChange(e);
    };

    return (
        <div className="form-input">
            <label htmlFor="firstName" className={required && "required"} >Prénom</label>
            <input
                pattern={patternListChoices?.firstname}
                type="text"
                name="firstName"
                defaultValue={value}
                onChange={handleChange}
                onBlur={handleChange}
                required={required}
            />
        </div>
    )
}